// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../vninvestcharts-widget/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../vninvestcharts-widget/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.usoHJ23RuK_R7pvcu9dn {
  position: fixed;
  inset: 0;
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.45);
}

.IfnENG3afjs9LMipMNa8 {
  min-width: 320px;
  max-width: 420px;
  max-height: 90vh;
  overflow-y: auto;
  border-radius: var(--vnsc-radius-modal, 12px);
  padding: var(--vnsc-space-modal-padding, 24px);
  background: var(--vnsc-bg-modal, #1e293b);
  color: var(--vnsc-text-primary, #e2e8f0);
  box-shadow: var(--vnsc-shadow-modal, 0 8px 32px rgba(0, 0, 0, 0.4));
  display: flex;
  flex-direction: column;
  gap: var(--vnsc-space-3, 12px);
  font-family: var(--vnsc-font-family-base);
  font-size: var(--vnsc-font-size-base, 13px);
}

.KvTwAWx7Jkryp5jc6npT {
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
  font-weight: 700;
}

.dOMYjfqoCmSzNZS7_gsq {
  border: none;
  background: transparent;
  color: inherit;
  font-size: 16px;
  cursor: pointer;
}

.xVwmZz1PvW_fP_WViQuQ {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
}

.xVwmZz1PvW_fP_WViQuQ .Hn3wjlEtc5hGAOU1npys,
.xVwmZz1PvW_fP_WViQuQ .ai1i5Juls6wJ8Z3DGT7Q {
  flex: 0 0 auto;
  min-width: 0;
  padding: 4px 6px;
  font-size: 11px;
  white-space: nowrap;
  overflow: visible;
  text-overflow: clip;
}

.Hn3wjlEtc5hGAOU1npys,
.ai1i5Juls6wJ8Z3DGT7Q {
  flex: 1;
  min-width: 0;
  padding: 5px 2px;
  border-radius: 6px;
  border: 1px solid var(--vnsc-border, #2a2a2a);
  background: transparent;
  color: inherit;
  cursor: pointer;
  font-size: 12px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.ai1i5Juls6wJ8Z3DGT7Q {
  background: var(--vnsc-accent, #2962ff);
  color: #fff;
}

/* Compact ticket: label + control share one row (Giá / Khối lượng /
   Chốt lời / Cắt lỗ inline instead of stacked full-width). */
.IJUBXaug8qbWdw3mfJth {
  display: grid;
  grid-template-columns: 88px minmax(0, 1fr);
  align-items: center;
  gap: 8px;
}

.IJUBXaug8qbWdw3mfJth input,
.lIV3GrmUEutrOAWuIoN3 input {
  padding: 5px 8px;
  border-radius: 6px;
  border: 1px solid var(--vnsc-border, #2a2a2a);
  background: var(--vnsc-bg-primary, #0d141b);
  color: inherit;
  min-width: 0;
  /* Giá/KL là số sống theo tick — tabular-nums để số không giật (AC6). */
  font-variant-numeric: tabular-nums;
}

.IJUBXaug8qbWdw3mfJth input {
  width: 100%;
  box-sizing: border-box;
}

.lIV3GrmUEutrOAWuIoN3 {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
}

/* Hierarchical section header (e.g. TP/SL unit): uppercase micro-label with
   a divider so users tell sections apart at a glance. */
.o0I7OxaPBqmuXCjrOvvw {
  display: block;
  width: 100%;
  margin-top: 4px;
  padding-top: 8px;
  border-top: 1px solid var(--vnsc-border-divider, #2a2a2a);
  font-size: 10px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: var(--vnsc-text-secondary, #787b86);
}

.lIV3GrmUEutrOAWuIoN3 label {
  display: flex;
  align-items: center;
  gap: 6px;
  white-space: nowrap;
}

.YBwGUiD3waR5TnqBO3FC {
  opacity: 0.75;
}

.BFbg48owe2Y043JqeFQi {
  display: flex;
  flex-direction: column;
  gap: 4px;
  opacity: 0.9;
}

.CChIvXalWfAa1y4xYf3F {
  color: var(--vnsc-color-error, #f87171);
}

/* ── Bước xác nhận lệnh (Pha 1 trust fixes) ─────────────────────────────────
   Review thay thế form in-place: user phải đọc số (giá trị lệnh, margin, sức mua)
   rồi mới bấm Xác nhận ⇒ không còn "1 click = mất tiền". */
.SC5Cy94z0Dck9jEecch3 {
  display: flex;
  flex-direction: column;
  gap: var(--vnsc-space-2, 8px);
}

.m4CcpHq1pzKa9z7UuF1d {
  font-size: 12px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: var(--vnsc-text-secondary, #787b86);
}

.zcfsAbNSkwZz1mB36_8k {
  display: flex;
  flex-direction: column;
  gap: 4px;
  margin: 0;
}

.HqZi_whaZtXnOdv0HbaG {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 8px;
  font-size: 12px;
}

._ju433rsONjvVH4gjLHI {
  color: var(--vnsc-text-secondary, #787b86);
  white-space: nowrap;
}

.boyNz2HtCoPXyeyww1_9 {
  margin: 0;
  font-weight: 600;
  font-variant-numeric: tabular-nums;
  text-align: right;
  overflow-wrap: anywhere;
}

.lW3WAGnW_ZSn3525adci {
  display: flex;
  gap: 8px;
  margin-top: var(--vnsc-space-2, 8px);
}

.lW3WAGnW_ZSn3525adci button {
  flex: 1;
  padding: 8px 12px;
  border-radius: 8px;
  cursor: pointer;
  font-weight: 600;
}

.lW3WAGnW_ZSn3525adci button:disabled {
  opacity: 0.45;
  cursor: not-allowed;
}

/* Nút xác nhận trong review: cùng ngôn ngữ màu với nút đặt lệnh (mua xanh / bán đỏ).
   Selector của footer không match ở đây (không có ancestor .footer) ⇒ cần rule riêng. */
.lW3WAGnW_ZSn3525adci button.Ig2Cla7mZw8UfuOQarki,
.lW3WAGnW_ZSn3525adci button.ZH_Zl1gm4osNES_M2EpQ {
  border: none;
  color: var(--vnsc-text-on-primary, #fff);
  font-weight: 600;
}

.lW3WAGnW_ZSn3525adci button.Ig2Cla7mZw8UfuOQarki {
  background: var(--vnsc-color-bullish, #16a34a);
}

.lW3WAGnW_ZSn3525adci button.ZH_Zl1gm4osNES_M2EpQ {
  background: var(--vnsc-color-bearish, #ef5350);
}

.rIjyLpocn_3CJBnWT4Oa {
  display: flex;
  gap: 8px;
  justify-content: flex-end;
}

.rIjyLpocn_3CJBnWT4Oa button {
  padding: 8px 16px;
  border-radius: 8px;
  cursor: pointer;
}

.rIjyLpocn_3CJBnWT4Oa button.Ig2Cla7mZw8UfuOQarki,
.rIjyLpocn_3CJBnWT4Oa button.ZH_Zl1gm4osNES_M2EpQ {
  border: none;
  color: var(--vnsc-text-on-primary, #fff);
  font-weight: 600;
}

.rIjyLpocn_3CJBnWT4Oa button.Ig2Cla7mZw8UfuOQarki {
  background: var(--vnsc-color-bullish, #16a34a);
}

.rIjyLpocn_3CJBnWT4Oa button.ZH_Zl1gm4osNES_M2EpQ {
  background: var(--vnsc-color-bearish, #ef5350);
}

.rIjyLpocn_3CJBnWT4Oa button:last-child:disabled {
  opacity: 0.45;
  cursor: not-allowed;
}
`, "",{"version":3,"sources":["webpack://./src/widget/trading/ticket/OrderTicketModal.module.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,QAAQ;EACR,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,+BAA+B;AACjC;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,6CAA6C;EAC7C,8CAA8C;EAC9C,yCAAyC;EACzC,wCAAwC;EACxC,mEAAmE;EACnE,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,yCAAyC;EACzC,2CAA2C;AAC7C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;AACV;;AAEA;;EAEE,cAAc;EACd,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;;EAEE,OAAO;EACP,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,6CAA6C;EAC7C,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,uCAAuC;EACvC,WAAW;AACb;;AAEA;6DAC6D;AAC7D;EACE,aAAa;EACb,0CAA0C;EAC1C,mBAAmB;EACnB,QAAQ;AACV;;AAEA;;EAEE,gBAAgB;EAChB,kBAAkB;EAClB,6CAA6C;EAC7C,2CAA2C;EAC3C,cAAc;EACd,YAAY;EACZ,uEAAuE;EACvE,kCAAkC;AACpC;;AAEA;EACE,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,QAAQ;AACV;;AAEA;wDACwD;AACxD;EACE,cAAc;EACd,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,yDAAyD;EACzD,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,uCAAuC;AACzC;;AAEA;;2DAE2D;AAC3D;EACE,aAAa;EACb,sBAAsB;EACtB,6BAA6B;AAC/B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,SAAS;AACX;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,8BAA8B;EAC9B,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,0CAA0C;EAC1C,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,gBAAgB;EAChB,kCAAkC;EAClC,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,oCAAoC;AACtC;;AAEA;EACE,OAAO;EACP,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;wFACwF;AACxF;;EAEE,YAAY;EACZ,wCAAwC;EACxC,gBAAgB;AAClB;;AAEA;EACE,8CAA8C;AAChD;;AAEA;EACE,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;;EAEE,YAAY;EACZ,wCAAwC;EACxC,gBAAgB;AAClB;;AAEA;EACE,8CAA8C;AAChD;;AAEA;EACE,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB","sourcesContent":[".overlay {\r\n  position: fixed;\r\n  inset: 0;\r\n  z-index: 1000;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  background: rgba(0, 0, 0, 0.45);\r\n}\r\n\r\n.modal {\r\n  min-width: 320px;\r\n  max-width: 420px;\r\n  max-height: 90vh;\r\n  overflow-y: auto;\r\n  border-radius: var(--vnsc-radius-modal, 12px);\r\n  padding: var(--vnsc-space-modal-padding, 24px);\r\n  background: var(--vnsc-bg-modal, #1e293b);\r\n  color: var(--vnsc-text-primary, #e2e8f0);\r\n  box-shadow: var(--vnsc-shadow-modal, 0 8px 32px rgba(0, 0, 0, 0.4));\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: var(--vnsc-space-3, 12px);\r\n  font-family: var(--vnsc-font-family-base);\r\n  font-size: var(--vnsc-font-size-base, 13px);\r\n}\r\n\r\n.header {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  font-size: 14px;\r\n  font-weight: 700;\r\n}\r\n\r\n.closeBtn {\r\n  border: none;\r\n  background: transparent;\r\n  color: inherit;\r\n  font-size: 16px;\r\n  cursor: pointer;\r\n}\r\n\r\n.tabs {\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  gap: 4px;\r\n}\r\n\r\n.tabs .tab,\r\n.tabs .activeTab {\r\n  flex: 0 0 auto;\r\n  min-width: 0;\r\n  padding: 4px 6px;\r\n  font-size: 11px;\r\n  white-space: nowrap;\r\n  overflow: visible;\r\n  text-overflow: clip;\r\n}\r\n\r\n.tab,\r\n.activeTab {\r\n  flex: 1;\r\n  min-width: 0;\r\n  padding: 5px 2px;\r\n  border-radius: 6px;\r\n  border: 1px solid var(--vnsc-border, #2a2a2a);\r\n  background: transparent;\r\n  color: inherit;\r\n  cursor: pointer;\r\n  font-size: 12px;\r\n  white-space: nowrap;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n}\r\n\r\n.activeTab {\r\n  background: var(--vnsc-accent, #2962ff);\r\n  color: #fff;\r\n}\r\n\r\n/* Compact ticket: label + control share one row (Giá / Khối lượng /\r\n   Chốt lời / Cắt lỗ inline instead of stacked full-width). */\r\n.field {\r\n  display: grid;\r\n  grid-template-columns: 88px minmax(0, 1fr);\r\n  align-items: center;\r\n  gap: 8px;\r\n}\r\n\r\n.field input,\r\n.row input {\r\n  padding: 5px 8px;\r\n  border-radius: 6px;\r\n  border: 1px solid var(--vnsc-border, #2a2a2a);\r\n  background: var(--vnsc-bg-primary, #0d141b);\r\n  color: inherit;\r\n  min-width: 0;\r\n  /* Giá/KL là số sống theo tick — tabular-nums để số không giật (AC6). */\r\n  font-variant-numeric: tabular-nums;\r\n}\r\n\r\n.field input {\r\n  width: 100%;\r\n  box-sizing: border-box;\r\n}\r\n\r\n.row {\r\n  display: flex;\r\n  align-items: center;\r\n  flex-wrap: wrap;\r\n  gap: 8px;\r\n}\r\n\r\n/* Hierarchical section header (e.g. TP/SL unit): uppercase micro-label with\r\n   a divider so users tell sections apart at a glance. */\r\n.sectionLabel {\r\n  display: block;\r\n  width: 100%;\r\n  margin-top: 4px;\r\n  padding-top: 8px;\r\n  border-top: 1px solid var(--vnsc-border-divider, #2a2a2a);\r\n  font-size: 10px;\r\n  font-weight: 700;\r\n  text-transform: uppercase;\r\n  letter-spacing: 0.05em;\r\n  color: var(--vnsc-text-secondary, #787b86);\r\n}\r\n\r\n.row label {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 6px;\r\n  white-space: nowrap;\r\n}\r\n\r\n.tifRow {\r\n  opacity: 0.75;\r\n}\r\n\r\n.preview {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 4px;\r\n  opacity: 0.9;\r\n}\r\n\r\n.error {\r\n  color: var(--vnsc-color-error, #f87171);\r\n}\r\n\r\n/* ── Bước xác nhận lệnh (Pha 1 trust fixes) ─────────────────────────────────\r\n   Review thay thế form in-place: user phải đọc số (giá trị lệnh, margin, sức mua)\r\n   rồi mới bấm Xác nhận ⇒ không còn \"1 click = mất tiền\". */\r\n.review {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: var(--vnsc-space-2, 8px);\r\n}\r\n\r\n.reviewTitle {\r\n  font-size: 12px;\r\n  font-weight: 700;\r\n  text-transform: uppercase;\r\n  letter-spacing: 0.05em;\r\n  color: var(--vnsc-text-secondary, #787b86);\r\n}\r\n\r\n.reviewRows {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 4px;\r\n  margin: 0;\r\n}\r\n\r\n.reviewRow {\r\n  display: flex;\r\n  align-items: baseline;\r\n  justify-content: space-between;\r\n  gap: 8px;\r\n  font-size: 12px;\r\n}\r\n\r\n.reviewLabel {\r\n  color: var(--vnsc-text-secondary, #787b86);\r\n  white-space: nowrap;\r\n}\r\n\r\n.reviewValue {\r\n  margin: 0;\r\n  font-weight: 600;\r\n  font-variant-numeric: tabular-nums;\r\n  text-align: right;\r\n  overflow-wrap: anywhere;\r\n}\r\n\r\n.reviewActions {\r\n  display: flex;\r\n  gap: 8px;\r\n  margin-top: var(--vnsc-space-2, 8px);\r\n}\r\n\r\n.reviewActions button {\r\n  flex: 1;\r\n  padding: 8px 12px;\r\n  border-radius: 8px;\r\n  cursor: pointer;\r\n  font-weight: 600;\r\n}\r\n\r\n.reviewActions button:disabled {\r\n  opacity: 0.45;\r\n  cursor: not-allowed;\r\n}\r\n\r\n/* Nút xác nhận trong review: cùng ngôn ngữ màu với nút đặt lệnh (mua xanh / bán đỏ).\r\n   Selector của footer không match ở đây (không có ancestor .footer) ⇒ cần rule riêng. */\r\n.reviewActions button.submitBuy,\r\n.reviewActions button.submitSell {\r\n  border: none;\r\n  color: var(--vnsc-text-on-primary, #fff);\r\n  font-weight: 600;\r\n}\r\n\r\n.reviewActions button.submitBuy {\r\n  background: var(--vnsc-color-bullish, #16a34a);\r\n}\r\n\r\n.reviewActions button.submitSell {\r\n  background: var(--vnsc-color-bearish, #ef5350);\r\n}\r\n\r\n.footer {\r\n  display: flex;\r\n  gap: 8px;\r\n  justify-content: flex-end;\r\n}\r\n\r\n.footer button {\r\n  padding: 8px 16px;\r\n  border-radius: 8px;\r\n  cursor: pointer;\r\n}\r\n\r\n.footer button.submitBuy,\r\n.footer button.submitSell {\r\n  border: none;\r\n  color: var(--vnsc-text-on-primary, #fff);\r\n  font-weight: 600;\r\n}\r\n\r\n.footer button.submitBuy {\r\n  background: var(--vnsc-color-bullish, #16a34a);\r\n}\r\n\r\n.footer button.submitSell {\r\n  background: var(--vnsc-color-bearish, #ef5350);\r\n}\r\n\r\n.footer button:last-child:disabled {\r\n  opacity: 0.45;\r\n  cursor: not-allowed;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"overlay": `usoHJ23RuK_R7pvcu9dn`,
	"modal": `IfnENG3afjs9LMipMNa8`,
	"header": `KvTwAWx7Jkryp5jc6npT`,
	"closeBtn": `dOMYjfqoCmSzNZS7_gsq`,
	"tabs": `xVwmZz1PvW_fP_WViQuQ`,
	"tab": `Hn3wjlEtc5hGAOU1npys`,
	"activeTab": `ai1i5Juls6wJ8Z3DGT7Q`,
	"field": `IJUBXaug8qbWdw3mfJth`,
	"row": `lIV3GrmUEutrOAWuIoN3`,
	"sectionLabel": `o0I7OxaPBqmuXCjrOvvw`,
	"tifRow": `YBwGUiD3waR5TnqBO3FC`,
	"preview": `BFbg48owe2Y043JqeFQi`,
	"error": `CChIvXalWfAa1y4xYf3F`,
	"review": `SC5Cy94z0Dck9jEecch3`,
	"reviewTitle": `m4CcpHq1pzKa9z7UuF1d`,
	"reviewRows": `zcfsAbNSkwZz1mB36_8k`,
	"reviewRow": `HqZi_whaZtXnOdv0HbaG`,
	"reviewLabel": `_ju433rsONjvVH4gjLHI`,
	"reviewValue": `boyNz2HtCoPXyeyww1_9`,
	"reviewActions": `lW3WAGnW_ZSn3525adci`,
	"submitBuy": `Ig2Cla7mZw8UfuOQarki`,
	"submitSell": `ZH_Zl1gm4osNES_M2EpQ`,
	"footer": `rIjyLpocn_3CJBnWT4Oa`
};
export default ___CSS_LOADER_EXPORT___;
